const hoverList = (): void => {
  const selectors = {
    hoverListSection: '[data-hover-list]',
    hoverListCurrent: 'data-hover-list-current',
    hoverListItem: '[data-hover-list-item]',
    hoverListItemID: 'data-hover-list-item',
    hoverListItemLink: '.item__link',
    hoverListItemDetails: '[data-hover-list-item-details]',
  };

  const classes = {
    open: 'list__item--open',
  };

  const isLargeScreen = (): boolean =>
    window.matchMedia('(min-width: 992px)').matches;

  const hoverListSections = document.querySelectorAll<HTMLElement>(
    selectors.hoverListSection
  );

  hoverListSections.forEach((section) => {
    const listItems = section.querySelectorAll<HTMLElement>(
      selectors.hoverListItem
    );

    listItems.forEach((item) => {
      // Desktop only: hovering a list item reveals its image alongside the list.
      // On touch, taps fire mouseover too — skip so items don't get the hover highlight.
      item.addEventListener('mouseover', () => {
        if (!isLargeScreen()) return;
        const itemID = item.getAttribute(selectors.hoverListItemID) || '';
        section.setAttribute(selectors.hoverListCurrent, itemID);
      });

      // Mobile: tapping a list item toggles its details dropdown
      const link = item.querySelector<HTMLElement>(selectors.hoverListItemLink);
      const details = item.querySelector<HTMLElement>(
        selectors.hoverListItemDetails
      );

      if (link && details) {
        link.addEventListener('click', (event) => {
          if (isLargeScreen()) return;

          event.preventDefault();

          if (item.classList.contains(classes.open)) {
            item.classList.remove(classes.open);
            details.style.maxHeight = '';
          } else {
            item.classList.add(classes.open);
            details.style.maxHeight = details.scrollHeight + 'px';
          }
        });
      }
    });

    // Keep open dropdown heights correct across resizes
    window.addEventListener('resize', () => {
      listItems.forEach((item) => {
        const details = item.querySelector<HTMLElement>(
          selectors.hoverListItemDetails
        );
        if (details && item.classList.contains(classes.open)) {
          details.style.maxHeight = details.scrollHeight + 'px';
        }
      });
    });
  });
};

export default hoverList;
